<template>
  <div class="hero-cta">
    <router-link :to="{ name: route, params: { type } }">
      <svg width="58px" height="58px" viewBox="0 0 58 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="HP" transform="translate(-392.000000, -3264.000000)">
                <g id="Group-6" transform="translate(392.000000, 2960.000000)">
                    <g id="btn1" transform="translate(0.000000, 304.000000)">
                        <circle id="Oval" fill="#679196" fill-rule="evenodd" cx="29" cy="29" r="29"></circle>
                        <polyline id="Path-3" stroke="#FFFFFF" stroke-width="1" points="16 31.0010778 41.9194336 31.0010778 36.3427006 26"></polyline>
                        <polyline id="backArrow" stroke="#FFFFFF" stroke-width="1" points="16 31.0010778 41.9194336 31.0010778 36.3427006 26"></polyline>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <span v-if="showLabel">{{ $t('scopriServizi') }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    route: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: () => true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

  .hero-cta{
    a svg{
      width: 58px;
      height: 58px;
      vertical-align: middle;
      margin-right: 2rem;
      @media #{$xlarge_mq} {
        margin-right: 3rem;
      }
    }

    a svg polyline#backArrow{
      transform: translate3d(-50px, 0, 0);
    }

    a svg polyline{
      transition: transform .8s cubic-bezier(.23,1,.32,1);
    }

    a:hover{

      svg polyline#Path-3{
        transform: translate3d(50px, 0, 0);
      }

      svg polyline#backArrow{
        transform: translate3d(0, 0, 0);
        transition-delay: .2s;
      }

    }

    a{
      font-size: 1.4rem;
      line-height: 1;
      color: #EFEFF1;
      text-decoration: none;
      display: inline-block;
      @media #{$xlarge_mq} {
        font-size: 1.6rem;
      }
    }

  }
</style>
